"use client"
import TermsTabs from './_components/TermsTabs'
import TermsLocationsDropdown from './_components/TermsLocationsDropdown'
import { useParams } from 'next/navigation'
import { useTranslations } from 'next-intl'

const layout =  ({ children }) => {
    const t = useTranslations('terms')
    const { location, service } = useParams()
    return (
      <main>
        <div className='container py-24'>
          <div>
            <h3 className='heading-common mb-[65px]'>{t(`title`)}</h3>
          </div>
          <TermsLocationsDropdown location={location} service={service} />
          <TermsTabs location={location} service={service} />
          {children}
        </div>
      </main>
    )
  }

export default layout
